Oskari.bundle_manager.registerDynamic('statsgrid', function() {return import(/* webpackChunkName: "chunk_statsgrid" */ 'oskari-loader!oskari-frontend/bundles/statistics/statsgrid/bundle.js');});
